export default __webpack_public_path__ + "5893d6751001a43ce12d319905ad1376.png";